import * as React from 'react';
/**
 * @ignore - internal component.
 */

var RadioGroupContext = /*#__PURE__*/React.createContext();

if (process.env.NODE_ENV !== 'production') {
  RadioGroupContext.displayName = 'RadioGroupContext';
}

export default RadioGroupContext;


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/RadioGroup/RadioGroupContext.js
// module id = 809
// module chunks = 121